import {Component} from 'react';
import React from 'react';


import { Form } from "rsuite";

export class CustomizableForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formValue: props.formValue || props.formDefaultValue || {}
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {clearOn, formDefaultValue} = this.props;
        
        if (clearOn !== null && clearOn !== prevProps.clearOn) {
            this.setState({formValue: formDefaultValue || {}});
        }
    }

    renderFields = (children) => {
        const {disabled} = this.props;

        return React.Children.map(children, child => {

            // return a child that is not a React element
            if (!React.isValidElement(child)) {
                return child
            }

            const props = {};

            // add status "disabled" to FormControl
            if (this.props.formDefaultValue) {
                if (Object.keys(this.props.formDefaultValue).includes(child.props.name)) {
                    props['disabled'] = disabled;
                }
            }

            // clone element children if it has
            if (child.props.children) {
                child = React.cloneElement(child, {
                    ...props,
                    children: this.renderFields(child.props.children)
                })
            } else {
                child = React.cloneElement(child, props)
            }

            // return cloned child
            return child
        })
    };

    render() {
        const {children} = this.props;
        const {formValue} = this.state;

        return (
            <Form
                {...(this.props.formDefaultValue ? {formValue: formValue} : {})}

                {...this.props}

                onChange={(value) => {
                    this.setState({formValue: value});
                    if (this.props?.onChange) {
                        this.props.onChange(value);
                    }
                }}
            >
                {this.renderFields(children)}
            </Form>
        )
    }
}